export const SIGN_SERVER = "1";
export const CLOUD_CA = "4";
export const HSM = "3";
export const USB_TOKEN = "2";

export const AUTH_TYPE = [
  {value: SIGN_SERVER, title: "Chữ ký server"},
  {value: CLOUD_CA, title: "CloudCA"},
  {value: HSM, title: "HSM"},
  {value: USB_TOKEN, title: "USB-TOKEN"},
];

export const ME_HSM_SIGNATURE = '2';
export const ME_CASH_NO_SIGNATURE = '5';
export const AUTH_ME_INVOICE = [
  {value: ME_HSM_SIGNATURE, title: 'Ký số qua HSM'},
  {
    value: ME_CASH_NO_SIGNATURE,
    title: 'Ký số sau loại Hóa đơn MTT',
  },
];

export const PAYMENT_METHOD = [
  "TM",
  "CK",
  "TM/CK",
];

export const COUNTRY_LIST = [
  {name: 'Việt Nam', phoneCode: '84', numcode: '704', currencyCode: 'VND', flag: 'https://flagcdn.com/w320/vn.png'}
]

export const SELECT_PLACEHOLDER = "--Lựa chọn--";
export const EXPORTED_INVOICE = 1;
// Số hoá đơn tối đa API đối tác cho phát hành trong 1 lần gọi
export const MAX_INVOICE_PER_REQUEST = 10;

export const INVOICE_PENDING_FILTER = [
  {id: true, label: 'Đã thanh toán'},
  {id: false, label: 'Chưa thanh toán'},
];

export const INVOICE_DRAFT_FILTER = [
  {id: true, label: 'Đã tạo hóa đơn nháp'},
  {id: false, label: 'Chưa tạo hóa đơn nháp'},
];

export const INVOICE_EXPORT_FILTER = [
  {id: 'code_not_sent', label: 'Chưa gửi'},
  {id: 'code_sent', label: 'Chờ CQT xác nhận'},
  {id: 'code_approved', label: 'HĐ hợp lệ'},
  {id: 'code_dis_approved', label: 'HĐ không hợp lệ'},
];
